export default __webpack_public_path__ + "static/media/tag-icon-skills.d541cb5d.svg";